import React from "react";
import ViewForm from "../ViewForm/ViewForm";
import { API_URLS } from "../../../../api/apiUrls";
const ViewAllQuestions = () => {
  return (
    <div className=" px-5 pb-5 ">
      <ViewForm
        sectionurl={API_URLS.GET_SECTIONS}
        subsectionurl={API_URLS.GET_SUBSECTIONS}
        questionurl={API_URLS.GET_CUSTOM_QUESTION}
      />
    </div>
  );
};

export default ViewAllQuestions;
